// extracted by mini-css-extract-plugin
export default {"errorMessage":"aBCnmTnkYLXLgXa3XcRfwQ==","icon":"WBxc9mxhPx7iNFfnecbV5Q==","text":"AuRTJ-7WZCVCEKJlFDeMUg=="};